import { DriverTeamsService, type PostDriverTeamAdminRequest } from '@/backend/market'
import { DriverTeamRepository } from '../../domain/repositories/DriverTeamRepository'
import { DriverTeamModel } from '../models/DriverTeamModel'
import type { DriverTeamsFilterEntity } from '../../domain/entities/DriverTeamsFilterEntity'
import { DriverTeamsFilterModel } from '../models/DriverTeamsFilterModel'
import { DriverTeamMiniModel } from '../models/DriverTeamMiniModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DriverTeamMiniEntity } from '../../domain/entities/DriverTeamMiniEntity'
import { CreateUpdateDriverTeamEntity } from '../../domain/entities/CreateUpdateDriverTeamEntity'
import { CreateUpdateDriverTeamModel } from '../models/CreateUpdateDriverTeamModel'
import type { DriverTeamEntity } from '../../domain/entities/DriverTeamEntity'

export class DriverTeamRepositoryImpl implements DriverTeamRepository {
  async getDriverTeams(
    filterData: DriverTeamsFilterEntity
  ): Promise<PaginateEntity<DriverTeamMiniEntity[]> | { error: true }> {
    const driverTeamsFilterModel = new DriverTeamsFilterModel(filterData)
    try {
      const response = await DriverTeamsService.getDriverTeamsAdmin(driverTeamsFilterModel)
      const driverTeamMiniModels = response.items?.map((item) => new DriverTeamMiniModel(item))
      const result = new PaginateEntity<DriverTeamMiniModel[]>(response, driverTeamMiniModels)

      return result
    } catch {
      return { error: true }
    }
  }
  async getDriverTeam(id: number): Promise<DriverTeamEntity | { error: true }> {
    try {
      const response = await DriverTeamsService.getDriverTeamAdmin({ id })

      const driverTeamModel = new DriverTeamModel(response)

      return driverTeamModel
    } catch {
      return { error: true }
    }
  }
  async createDriverTeam(
    driverTeamData: CreateUpdateDriverTeamEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateDriverTeamEntity = new CreateUpdateDriverTeamModel(driverTeamData)
    try {
      await DriverTeamsService.postDriverTeamAdmin({
        requestBody: createUpdateDriverTeamEntity as PostDriverTeamAdminRequest
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateDriverTeam(
    id: number,
    driverTeamData: CreateUpdateDriverTeamEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateDriverTeamEntity = new CreateUpdateDriverTeamModel(driverTeamData)
    try {
      await DriverTeamsService.putDriverTeamAdmin({
        id,
        requestBody: createUpdateDriverTeamEntity as PostDriverTeamAdminRequest
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteDriverTeam(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await DriverTeamsService.deleteDriverTeamAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
